import Route from './maternal-form-constants'

export default([
  {
    id              : 'admission',
    label           : 'Admission',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_ADMISSION_ID,
  },
  {
    id              : 'obScore',
    label           : 'Obstetric History',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_OB_SCORE_ID,
  },
  {
    id              : 'pregnancy',
    label           : 'Delivery',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_PREG_DELIVERY_ID,
  },
  {
    id              : 'medHistory',
    label           : 'Co-morbidities',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_MED_HIST_ID,
  },
  {
    id              : 'gyne',
    label           : 'Gynecological Conditions',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_GYNE_ID,
  },
  {
    id              : 'migsInfo',
    label           : 'MIGS Information',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_DISCHARGE_ID
  },
  {
    id              : 'discharge',
    label           : 'Discharge',
    validationNotif : 'alert',
    sectionID       : Route.FORM_SECTION_DISCHARGE_ID
  }
])
